import React from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import PropTypes from "prop-types";

/**
 * KeyboardDatePicker component wrapper for date selection.
 * Wraps Material-UI KeyboardDatePicker for consistent imports.
 * 
 * @component
 * @example
 * <KeyboardDatePicker
 *   label="Select Date"
 *   value={selectedDate}
 *   onChange={handleDateChange}
 * />
 */
const KeyboardDatePickerWrapper = ({ ...props }) => {
  return <KeyboardDatePicker {...props} />;
};

KeyboardDatePickerWrapper.propTypes = {
  /**
   * The label of the input
   */
  label: PropTypes.string,
  /**
   * The selected date value
   */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * Callback fired when the date is changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The id of the input
   */
  id: PropTypes.string,
  /**
   * If true, the input is required
   */
  required: PropTypes.bool,
  /**
   * If true, the input is disabled
   */
  disabled: PropTypes.bool,
  /**
   * The format of the date
   */
  format: PropTypes.string,
  /**
   * The views to show
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["year", "month", "date"])),
  /**
   * The maximum date that can be selected
   */
  maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * The minimum date that can be selected
   */
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * If true, the input will show an error state
   */
  error: PropTypes.bool,
  /**
   * The variant of the input
   */
  inputVariant: PropTypes.oneOf(["standard", "outlined", "filled"]),
  /**
   * The variant of the picker
   */
  variant: PropTypes.oneOf(["dialog", "inline", "static"]),
};

export default KeyboardDatePickerWrapper;
